// extracted by mini-css-extract-plugin
export default {"modalOverlay":"gN-z","modalContent":"hN-z","header":"iN-z","close":"jN-z"};